import React, { Component } from 'react'

import { FormattedMessage } from 'react-intl'
import cx from 'classnames'
import _ from 'lodash'

import { LOCALE_PREFIX, SCORING_CODES } from './constants'

import './style.scss'

export default class BisnodeScoringTooltip extends Component {
    render() {
        return (
            <div>
                <FormattedMessage
                    id={`${LOCALE_PREFIX}.bisnodeScooringTooltipMain`}
                    values={{ br: <br />, strong: (chunks) => <strong>{chunks}</strong> }}
                />
                {SCORING_CODES.map((scoringCode) => (
                    <div key={`bisnode-scoring-tooltip-element-${scoringCode}`}>
                        <div className={cx('scooring-tooltip-icon', scoringCode)}>{_.toUpper(scoringCode)}</div>
                        <FormattedMessage id={`${LOCALE_PREFIX}.${scoringCode}`} />
                    </div>
                ))}
                <div>
                    <div className={cx('scooring-tooltip-icon', 'na')}>N/A</div>
                    <FormattedMessage id={`${LOCALE_PREFIX}.na`} />
                </div>
            </div>
        )
    }
}
